import React, { useState } from 'react';
import LeadershipPrinciples from './LeadershipPrinciples';

const Header = ({ data }) => {
   const [mobileNavOpen, setMobileNavOpen] = useState(false);
   const [dropdownOpen, setDropdownOpen] = useState(false);

   const [sweSubmenuOpen, setSweSubmenuOpen] = useState(false);

   const toggleMobileNav = () => {
      setMobileNavOpen(!mobileNavOpen);
      if (mobileNavOpen) {
         setDropdownOpen(false);
         setSweSubmenuOpen(false);
      }
   };

   const toggleDropdown = (e) => {
      if (window.innerWidth <= 768) {
         e.preventDefault();
         setDropdownOpen(!dropdownOpen);
      }
   };

   const toggleSweSubmenu = (e) => {
      if (window.innerWidth <= 768) {
         e.preventDefault();
         setSweSubmenuOpen(!sweSubmenuOpen);
      } else {
         setMobileNavOpen(false);
      }
   };

   if (!data) return null;

   const { name, occupation, description, social, image } = data;
   const fullName = name === 'Guru' ? 'Guru Krishnamurthy' : name;

   const networks = social.map((network) => {
      const Icon = () => {
         if (network.name === 'linkedin') return <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.784 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>;
         if (network.name === 'github') return <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.042-1.416-4.042-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" /></svg>;
         return <i className={network.className}></i>;
      };
      return (
         <li key={network.name}>
            <a href={network.url} target="_blank" rel="noopener noreferrer" aria-label={network.name}>
               <Icon />
            </a>
         </li>
      );
   });

   return (
      <header id="home">
         <nav id="nav-wrap">
            <div className="mobile-btn" onClick={toggleMobileNav}>
               {mobileNavOpen ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
               ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>
               )}
            </div>

            <ul id="nav" className={mobileNavOpen ? "nav mobile-open" : "nav"}>
               <li className="current">
                  <a className="smoothscroll" href="#home" onClick={() => setMobileNavOpen(false)}>
                     Home
                  </a>
               </li>
               <li>
                  <a className="smoothscroll" href="#about" onClick={() => setMobileNavOpen(false)}>
                     About
                  </a>
               </li>
               <li>
                  <a className="smoothscroll" href="#resume" onClick={() => setMobileNavOpen(false)}>
                     Resume
                  </a>
               </li>
               <li>
                  <a className="smoothscroll" href="#portfolio" onClick={() => setMobileNavOpen(false)}>
                     Projects
                  </a>
               </li>
               <li>
                  <a className="smoothscroll" href="#testimonials" onClick={() => setMobileNavOpen(false)}>
                     Testimonials
                  </a>
               </li>
               <li className={`nav-item-dropdown ${dropdownOpen ? 'mobile-dropdown-open' : ''}`}>
                  <a href="#swe" onClick={toggleDropdown}>
                     Professional <span className="dropdown-indicator">{dropdownOpen ? '▲' : '▼'}</span>
                  </a>
                  <ul className="dropdown-menu">
                     <li>
                        <a href="#pdm" onClick={() => setMobileNavOpen(false)}>PDM</a>
                     </li>
                     <li>
                        <a href="#tpm" onClick={() => setMobileNavOpen(false)}>TPM</a>
                     </li>
                     <li>
                        <a href="#em" onClick={() => setMobileNavOpen(false)}>EM</a>
                     </li>
                     <li className={sweSubmenuOpen ? 'submenu-open' : ''}
                        onMouseEnter={() => window.innerWidth > 768 && setSweSubmenuOpen(true)}
                        onMouseLeave={() => window.innerWidth > 768 && setSweSubmenuOpen(false)}>
                        <a href="#swe" onClick={toggleSweSubmenu}>
                           SWE <span className="submenu-indicator">▶</span>
                        </a>
                        <ul className={sweSubmenuOpen ? "submenu active" : "submenu"}>
                           <li><a href="#java-interview" onClick={() => setMobileNavOpen(false)}>Java Interview</a></li>
                           <li><a href="#springboot" onClick={() => setMobileNavOpen(false)}>Spring Boot Deep Dive</a></li>
                           <li><a href="#java-deep-dive" onClick={() => setMobileNavOpen(false)}>Java & OOPs Deep Dive</a></li>
                        </ul>
                     </li>
                  </ul>
               </li>

               <li>
                  <a className="smoothscroll" href="#contact" onClick={() => setMobileNavOpen(false)}>
                     Contact
                  </a>
               </li>
               <li className="nav-assistant-link">
                  <a href="#assistant" onClick={() => setMobileNavOpen(false)}>
                     AI Assistant
                  </a>
               </li>
            </ul>
         </nav>

         <div className="row banner">
            <div className="executive-hero-grid">
               {/* LEFT COLUMN: Headline, Badges, Highlights & Actions */}
               <div className="hero-left-content">
                  <div className="status-badge">
                     <span className="status-dot"></span> Senior Technology Manager @ American Express
                  </div>

                  <h1 className="hero-name">
                     Guru <span className="highlight-gradient">Krishnamurthy</span>
                  </h1>

                  <h2 className="hero-title">{occupation}</h2>

                  <div className="hero-key-highlights">
                     <div className="highlight-pill">
                        <span className="highlight-icon">⚡</span>
                        <span><strong>20+ Years</strong> Leadership in Fintech, Payments & Retail Tech</span>
                     </div>
                     <div className="highlight-pill">
                        <span className="highlight-icon">🤖</span>
                        <span><strong>Agentic AI & Platform Strategy</strong> (LangGraph, AWN, ACE Registry)</span>
                     </div>
                     <div className="highlight-pill">
                        <span className="highlight-icon">🚀</span>
                        <span>Enterprise Impact at <strong>American Express</strong>, <strong>Amazon</strong> & <strong>Nordstrom</strong></span>
                     </div>
                  </div>

                  <div className="hero-action-pills">
                     <a href="#assistant" className="hero-pill primary"><span className="pill-icon">✨</span> Ask Saara AI Coach</a>
                     <a href="#resume" className="hero-pill secondary"><span className="pill-icon">💼</span> Experience Timeline</a>
                     <a href="#portfolio" className="hero-pill accent"><span className="pill-icon">🚀</span> Live Apps & Labs</a>
                  </div>

                  <div className="hero-social-row">
                     <span className="connect-label">Connect:</span>
                     <ul className="social">{networks}</ul>
                  </div>
               </div>

               {/* RIGHT COLUMN: Executive Profile Portrait */}
               <div className="hero-right-media">
                  <div className="hero-portrait-frame">
                     <div className="portrait-glow-ring"></div>
                     <img
                        className="profile-pic-hero"
                        src={image}
                        alt={`${fullName}'s Profile`}
                     />
                  </div>
               </div>
            </div>

            {/* COMPANY CREDIBILITY LOGO TICKER */}
            <div className="hero-company-ticker">
               <span className="ticker-label">Enterprise Technology & Leadership Experience</span>
               <div className="company-logos">
                  <span className="company-logo-badge amex">AMERICAN EXPRESS</span>
                  <span className="company-logo-badge amazon">AMAZON</span>
                  <span className="company-logo-badge nordstrom">NORDSTROM</span>
                  <span className="company-logo-badge tcs">TCS</span>
                  <span className="company-logo-badge atos">ATOS</span>
               </div>
            </div>

            {/* ROTATING LEADERSHIP PRINCIPLES STRIP */}
            <div className="hero-principles-strip">
               <LeadershipPrinciples />
            </div>
         </div>

         <p className="scrolldown">
            <a className="smoothscroll" href="#about" aria-label="Scroll Down">
               <i className="icon-down-circle"></i>
            </a>
         </p>
      </header>
   );
};

export default Header;
